/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useLocation, useNavigate } from "react-router-dom";
import { getPaymentStatus } from "../core/_requests";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import ListPlans from "./ListSubscription";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const sessionIdFromUrl = urlParams.get("session_id");

  //  Safe UserId getter
  const getSafeUserId = () => {
    const stored = localStorage.getItem("userId");
    if (!stored || stored === "undefined" || stored === "null") {
      return null;
    }
    return stored;
  };

  const sessionId = sessionIdFromUrl || localStorage.getItem("sessionId");
  const subscribedPlanId = localStorage.getItem("subscribedPlanId");
  const userId = getSafeUserId();

  const [result, setResult] = useState<{ message: string; status: boolean } | null>(null);

  const checkPaymentStatus = async () => {
    

    if (!sessionId || !subscribedPlanId || !userId) {
      console.warn(" Missing data, redirecting back", { sessionId, subscribedPlanId, userId });
      navigate(userId ? `/subscriptions/${userId}` : "/subscription");
      return;
    }

    try {
      const res = await getPaymentStatus(sessionId, subscribedPlanId);
      

      if (res?.status) {
        setResult(res);
        toast.success(res?.message || "Payment verified successfully!", { autoClose: 5000 });

        localStorage.setItem("subscribedPlanActive", "true");
        

        localStorage.removeItem("sessionId");
        localStorage.removeItem("subscribedPlanId");
        
      } else {
        console.warn("⚠️ Payment not successful, redirecting back");
        navigate(`/subscriptions/${userId}`);
      }
    } catch (error: any) {
      console.error("❌ Error checking payment status:", error);
      navigate(userId ? `/subscriptions/${userId}` : "/subscription");
    }
  };

  useEffect(() => {
    checkPaymentStatus();
  }, []);

  return (
    <section className="container-fluid">
      <ListPlans />
      <div className="overlay"></div>
      <div className="drawer ps-5 addon-wrap">
        <div className="alert-wrap">
          <img
            className="ico mb-2"
            src="/assets/images/alert-success-ico.svg"
            alt="success"
          />
          <h1 className="mb-4">Awesome!</h1>
          <p className="mid-gray mb-2 ps-3">
            <small>{result?.message || "Plan activated successfully"} </small>
          </p>
          <button
            className="btn btn-cancel rounded-5 btn-outline-primary mt-3"
            onClick={() =>
              navigate(userId ? `/subscriptions/${userId}` : "/subscription")
            }
          >
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default PaymentSuccess;
